var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43928 10.5684C7.17425 10.3878 6.82575 10.3878 6.56072 10.5684L4.09501 12.2479C3.49 12.66 2.70166 12.0873 2.90664 11.3845L3.74202 8.52047C3.83181 8.21262 3.72412 7.88118 3.47053 7.68491L1.11126 5.85888C0.532358 5.41083 0.833476 4.48408 1.56518 4.46187L4.54717 4.37133C4.8677 4.36159 5.14964 4.15675 5.25795 3.85492L6.26554 1.04685C6.51278 0.357826 7.48722 0.357827 7.73446 1.04685L8.74205 3.85492C8.85036 4.15675 9.1323 4.36159 9.45283 4.37133L12.4348 4.46187C13.1665 4.48408 13.4676 5.41083 12.8887 5.85888L10.5295 7.68491C10.2759 7.88118 10.1682 8.21262 10.258 8.52047L11.0934 11.3845C11.2983 12.0873 10.51 12.66 9.90499 12.2479L7.43928 10.5684Z",
    fill: "#FF9600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/rating_star.a7b497ce6bc67d258731f17daca91250.svg";
export { ForwardRef as ReactComponent };